let practice_account_setup_exit_intent = function( $ ) {

	let modal_open,
		$body,
		$modal,
		$links;

	let _init = function() {
		$body  = $( 'body' );
		$modal = $( '#practice-account-setup-exit-intent-popup' );
		$links = $( 'a' );

		if ( $modal.length > 0 ) {
			_setup_triggers();
			_attach_handlers();
		}
	};

	let _setup_triggers = function() {
		$links.each( ( index, item ) => {
			let $item = $( item );

			if ( ! $item.attr( 'href' ).startsWith( '#' ) && ! $item.hasClass( 'allow-exit' ) ) {
				$item.on( 'click', function( e ) {
					e.preventDefault();
					_open_modal( $item.attr( 'href' ) );
					window.onbeforeunload = function() {} // Dont show browser popup
				} );
			} else if ( $( $item.hasClass( 'allow-exit' ) ) ) {
				$item.on( 'click', function( e ) {
					window.onbeforeunload = function() {} // Dont show browser popup
				} );
			}
		} );

		window.onbeforeunload = _confirm_message_on_leave;
	};

	let _confirm_message_on_leave = function( e ) {
		// If we haven't been passed the event get the window.event
		e = e || window.event;

		let message = 'If you leave now you will lose your changes';

		// For IE6-8 and Firefox prior to version 4
		if ( e ) {
			e.returnValue = message;
		}

		// For Chrome, Safari, IE8+ and Opera 12+
		return message;
	};

	let _attach_handlers = function() {
		$modal.find( 'a.close-modal' ).on( 'click', _close_modal );
		$body.find( '.overlay' ).on( 'click', _close_modal );
	};

	let _open_modal = function( leave_link ) {
		$body.addClass( 'modal-open' );
		$body.find( '.overlay' ).fadeIn();

		modal_open = true;

		if ( leave_link ) {
			$modal.find( '.leave-account-setup' ).on( 'click', function( e ) {
				e.preventDefault();
				window.location.href = leave_link;
			} )
		} else {
			$modal.find( '.leave-account-setup' ).off( 'click' );
		}

		$modal.fadeIn();
	};

	let _close_modal = function () {
		if ( ! $body.hasClass( 'modal-open' ) ) {
			return;
		}

		modal_open = false;

		$body.removeClass( 'modal-open' );
		$body.find( '.overlay' ).fadeOut();

		$modal.fadeOut();
	};

	$( document ).ready( _init );

} (jQuery);

module.exports = practice_account_setup_exit_intent;